import './privacy-policy.scss'
import '@client/layouts/layout_common/layout_common'
